export const nudge = {
    de: {
        title: "Versteckte Helfer: Wie Institutionen deine Auswahl beeinflussen",
        description: "Hier untersuchen wir, wie Labels deine Entscheidungen beeinflussen können.",
        screens: {
            muesliGood: {
                title: "Für welches Müsli entscheidest du dich?",
                description:
                    "Du bist mit deinen Eltern im Supermarkt und darfst dir ein Schoko-Müsli aussuchen. Zwei Packungen gefallen dir besonders und du vergleichst sie. Auf der Rückseite findest du folgende Angaben:",
                features: [
                    "Vegetarisch",
                    "Ohne Ei",
                    "Ohne Rosinen",
                    "Ballaststoffquelle",
                    "Vollkorn",
                    "Knusprig",
                    "Mit Schokolade"
                ],
                allergens: "Kann weitere Schalenfrüchte enthalten.",
                nutritionTable: {
                    "Energie (kJ)": "1866",
                    "Energie (kcal)": "444",
                    "Fett (g)": "16",
                    "davon gesättigte Fettsäuren (g)": "5,5",
                    "Kohlenhydrate (g)": "64",
                    "davon Zucker (g)": "22",
                    "Eiweiß (g)": "8,5",
                    "Salz (g)": "0,25"
                },
                ingredients: {
                    getreide: "Hafer, Weizen, Gerste",
                    schokolade: "Dunkle Schokolade",
                    nuessen: "Haselnuss"
                },
                nameA: "Choco Crunchy von Knüller",
                nameB: "Choco Crunchy von FitMüsli",
                optionA: "Choco Crunchy von Knüller",
                optionB: "Choco Crunchy von FitMüsli (mit NutriScore B)",
                nutriScore: "NutriScore: B"
            },
            muesliBad: {
                title: "Für welches Müsli entscheidest du dich?",
                description:
                    "Du bist mit deinen Eltern im Supermarkt und darfst dir ein Schoko-Müsli aussuchen. Zwei Packungen gefallen dir besonders und du vergleichst sie. Auf der Rückseite findest du folgende Angaben:",
                features: [
                    "Vegetarisch",
                    "Ohne Ei",
                    "Ohne Rosinen",
                    "Ballaststoffquelle",
                    "Vollkorn",
                    "Knusprig",
                    "Mit Schokolade"
                ],
                allergens: "Kann weitere Schalenfrüchte enthalten.",
                nutritionTable: {
                    "Energie (kJ)": "1866",
                    "Energie (kcal)": "444",
                    "Fett (g)": "16",
                    "davon gesättigte Fettsäuren (g)": "5,5",
                    "Kohlenhydrate (g)": "64",
                    "davon Zucker (g)": "22",
                    "Eiweiß (g)": "8,5",
                    "Salz (g)": "0,25"
                },
                ingredients: {
                    getreide: "Hafer, Weizen, Gerste",
                    schokolade: "Dunkle Schokolade",
                    nuessen: "Haselnuss"
                },
                nameA: "Schoko-Knusper von Knüller",
                nameB: "Schoko-Knusper von Dr Crunch",
                optionA: "Schoko-Knusper von Knüller",
                optionB: "Schoko-Knusper von Dr Crunch (mit NutriScore D)",
                nutriScore: "NutriScore: D"
            },
            tvGood: {
                title: "Welchen Fernseher würdest du kaufen?",
                description:
                    "Euer Fernseher ist kaputtgegangen und ihr sucht gemeinsam mit deiner Familie einen Ersatz. Das Budget beträgt maximal 1.000 €. Du hast auf der Webseite eines Elektrofachmarkts zwei Angebote ausgesucht und vergleichst sie jetzt. Welchen dieser beiden Fernseher würdest du deinen Eltern eher empfehlen?",
                optionA: "OptiLux Vision 65U",
                optionB: "Solaire PureQLED 65",
                price: "899 €",
                data: [
                    { label: "Produkttyp", value: "QLED TV" },
                    { label: "Bildqualität", value: "UHD 4K" },
                    { label: "Bildschirmdiagonale (cm/Zoll)", value: "163 cm / 65 Zoll" },
                    { label: "Abmessungen ohne Standfuß (BxHxT)", value: "1456.8 mm / 831.9 mm / 24.9 mm" },
                    { label: "SMART TV", value: "Ja" },
                    { label: "Anschlüsse", value: "4x HDMI, 2x USB" },
                    { label: "Stromverbrauch", value: "95 Watt" }
                ]
            },
            tvBad: {
                title: "Welchen Fernseher würdest du kaufen?",
                description:
                    "Euer Fernseher ist kaputtgegangen und ihr sucht gemeinsam mit deiner Familie einen Ersatz. Das Budget beträgt maximal 1.000 €. Du hast auf der Webseite eines Elektrofachmarkts zwei Angebote ausgesucht und vergleichst sie jetzt. Welchen dieser beiden Fernseher würdest du deinen Eltern eher empfehlen?",
                optionA: "OptiLux Vision 65U",
                optionB: "Solaire PureQLED 65",
                price: "899 €",
                data: [
                    { label: "Produkttyp", value: "QLED TV" },
                    { label: "Bildqualität", value: "UHD 4K" },
                    { label: "Bildschirmdiagonale (cm/Zoll)", value: "163 cm / 65 Zoll" },
                    { label: "Abmessungen ohne Standfuß (BxHxT)", value: "1456.8 mm / 831.9 mm / 24.9 mm" },
                    { label: "SMART TV", value: "Ja" },
                    { label: "Anschlüsse", value: "4x HDMI, 2x USB" },
                    { label: "Stromverbrauch", value: "95 Watt" }
                ]
            },
            justify: {
                title: "Warum hast du dich so entschieden?",
                placeholder: "Beschreibe kurz, was für deine Wahl am wichtigsten war ..."
            },
            results: {
                title: "Deine Ergebnisse",
                description: "Hier siehst du deine Auswahl und wie andere Teilnehmer:innen entschieden haben."
            }
        }
    },
    en: {
        title: "Hidden Helpers: How Institutions Steer Your Descisions",
        description: "Here we investigate how labels can influence your decisions.",
        screens: {
            muesliGood: {
                title: "Which Muesli Do You Choose?",
                description:
                    "You’re at the supermarket with your parents and get to choose a chocolate muesli. Two boxes catch your eye, so you compare the information on the back:",
                features: [
                    "Vegetarian",
                    "Egg-free",
                    "No raisins",
                    "Source of fiber",
                    "Whole grain",
                    "Crunchy",
                    "With chocolate"
                ],
                allergens: "May contain other tree nuts.",
                nutritionTable: {
                    "Energy (kJ)": "1866",
                    "Energy (kcal)": "444",
                    "Fat (g)": "16",
                    "of which saturates (g)": "5.5",
                    "Carbohydrates (g)": "64",
                    "of which sugars (g)": "22",
                    "Protein (g)": "8.5",
                    "Salt (g)": "0.25"
                },
                ingredients: {
                    grains: "Oats, wheat, barley",
                    chocolate: "Dark chocolate",
                    nuts: "Hazelnut"
                },
                nameA: "Choco Crunchy by CrunchMasters",
                nameB: "Choco Crunchy by FitMuesli",
                optionA: "Choco Crunchy by CrunchMasters",
                optionB: "Choco Crunchy by FitMuesli (NutriScore B label)",
                nutriScore: "NutriScore: B"
            },
            muesliBad: {
                title: "Which Muesli Do You Choose?",
                description:
                    "You’re at the supermarket with your parents and get to choose a chocolate muesli. Two boxes catch your eye, so you compare the information on the back:",
                features: [
                    "Vegetarian",
                    "Egg-free",
                    "No raisins",
                    "Source of fiber",
                    "Whole grain",
                    "Crunchy",
                    "With chocolate"
                ],
                allergens: "May contain other tree nuts.",
                nutritionTable: {
                    "Energy (kJ)": "1866",
                    "Energy (kcal)": "444",
                    "Fat (g)": "16",
                    "of which saturates (g)": "5.5",
                    "Carbohydrates (g)": "64",
                    "of which sugars (g)": "22",
                    "Protein (g)": "8.5",
                    "Salt (g)": "0.25"
                },
                ingredients: {
                    grains: "Oats, wheat, barley",
                    chocolate: "Dark chocolate",
                    nuts: "Hazelnut"
                },
                nameA: "Choco Crispy by CrunchMasters",
                nameB: "Choco Crispy by Dr Crunch",
                optionA: "Choco Crispy by CrunchMasters",
                optionB: "Choco Crispy by Dr Crunch (NutriScore D label)",
                nutriScore: "NutriScore: D"
            },
            tvGood: {
                title: "Which TV Would You Buy?",
                description:
                    "Your TV is broken and you and your family are looking for a replacement. The budget is a maximum of €1,000. You have selected two offers on the website of an electronics retailer and are now comparing them. Which of these two TVs would you rather recommend to your parents?",
                optionA: "OptiLux Vision 65U",
                optionB: "Solaire PureQLED 65",
                price: "$899",
                data: [
                    { label: "Product type", value: "QLED TV" },
                    { label: "Picture quality", value: "UHD 4K" },
                    { label: "Screen size (cm/inch)", value: "163 cm / 65 inch" },
                    { label: "Dimensions w/o stand (W x H x D)", value: "1456.8 mm / 831.9 mm / 24.9 mm" },
                    { label: "SMART TV", value: "Yes" },
                    { label: "Ports", value: "4x HDMI, 2x USB" },
                    { label: "Power consumption", value: "95 Watt" }
                ]
            },
            tvBad: {
                title: "Which TV Would You Buy?",
                description:
                    "Your TV is broken and you and your family are looking for a replacement. The budget is a maximum of 1,000€. You have selected two offers on the website of an electronics retailer and are now comparing them. Which of these two TVs would you rather recommend to your parents?",
                optionA: "OptiLux Vision 65U",
                optionB: "Solaire PureQLED 65",
                price: "$899",
                data: [
                    { label: "Product type", value: "QLED TV" },
                    { label: "Picture quality", value: "UHD 4K" },
                    { label: "Screen size (cm/inch)", value: "163 cm / 65 inch" },
                    { label: "Dimensions w/o stand (W x H x D)", value: "1456.8 mm / 831.9 mm / 24.9 mm" },
                    { label: "SMART TV", value: "Yes" },
                    { label: "Ports", value: "4x HDMI, 2x USB" },
                    { label: "Power consumption", value: "95 Watt" }
                ]
            },
            justify: {
                title: "Why Did You Choose That Option?",
                placeholder: "Briefly explain what was most important in your decision ..."
            },
            results: {
                title: "Your Results",
                description: "Here you can see your choices and how other participants decided."
            }
        }
    },
};